import React from "react";
import TabBar, { TabBarProps } from "../../../../shared/components/TabBar";

interface OutsourceOrderTabNavigationProps {
    outsourceOrderInfoTab: React.ReactNode;
    outsourceOrderImportRequestsTab: React.ReactNode;
    outsourceOrderTrackingTab: React.ReactNode;
}

const OutsourceOrderTabNavigation = ({
    outsourceOrderInfoTab,
    outsourceOrderImportRequestsTab,
    outsourceOrderTrackingTab,
}: OutsourceOrderTabNavigationProps) => {
    const tabs: TabBarProps[] = [
        {
            label: "Thông tin",
            labelEN: "info",
            content: outsourceOrderInfoTab,
        },
        {
            label: "Đề nghị nhập kho",
            labelEN: "import requests",
            content: outsourceOrderImportRequestsTab,
        },
        {
            label: "Theo dõi gia công",
            labelEN: "tracking",
            content: outsourceOrderTrackingTab,
        },
    ];

    return <TabBar tabs={tabs} />;
};

export default OutsourceOrderTabNavigation;
